import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { darken, lighten } from "polished";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage, { set } from "local-storage";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
  Box,
  Select,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import Swal from "sweetalert2";
import moment from "moment";
import { cleanupLocalStorage } from "../../utils/localStorage/cleanupLocalStorage.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import AddFinancialTransactionModal from "./addTransaction.js";
import { getFinancialTransactions } from "../../api/financialTransactions/getFinancialTransactions.js";
import { getTaxPayerList } from "../../api/taxPayer/getTaxPayerList/index.js";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import EditFinancialTransactionModal from "./editTransaction";
import { deleteForFinancialTransaction } from "../../api/financialTransactions/deleteFinancialTransaction.js";
function FinancialTransaction() {
  const [rowData, setRowData] = useState([]);

  const [pageSize, setPageSize] = useState(250);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [taxpayerList, setTaxpayerList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const today = moment().format("YYYY-MM-DD");
  const monthAgo = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(monthAgo);
  const [endDate, setEndDate] = useState(today);

  const [isOpen, setIsOpen] = useState(false);

  const [gridApi, setGridApi] = useState(null);

  const [editModalOpen, setEditModalOpen] = useState(false);
  useEffect(() => {
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    localStorage.get("scrollPosition");

    search();
    cleanupLocalStorage();
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [selectedTaxpayerId, setSelectedTaxpayerId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchForTransaction, setSearchForTransaction] = useState(false);
  const [modalOpenForTransaciton, setModalOpenForTransaciton] = useState(false);

  const openModal = (id) => {
    setSelectedTaxpayerId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedTaxpayerId(null);
  };

  // const onSelectionChanged = (event) => {
  //   const selectedNodes = event.api.getSelectedNodes();

  //   const selectedIds = selectedNodes.map((node) => node.data.id);
  //   // console.log(selectedIds, "selectedIds1");
  //   setSelectedIds(selectedIds);

  //   const selectedTaxPayersVknTckn = selectedNodes.flatMap((node) => {
  //     const values = [];
  //     if (node.data.vkn) values.push(node.data.vkn); // VKN her zaman eklenecek
  //     if (node.data.tckn) values.push(node.data.tckn); // TCKN boş değilse eklenecek
  //     return values;
  //   });

  //   // console.log(selectedTaxPayersVknTckn, "selectedTaxPayersVknTckn");
  //   setSelectedTaxPayersVknTckn(selectedTaxPayersVknTckn);
  //   const selectedTaxPayersTitle = selectedNodes.map((node) => node.data.title);
  //   setSelectedTaxPayersTitle(selectedTaxPayersTitle);
  //   //console.log(selectedTaxPayers,selectedIds);

  //   const selectedTaxPayersData = selectedIds.map((id, index) => ({
  //     id: id,
  //     name: selectedTaxPayersTitle[index],
  //   }));
  //   setSelectedTaxPayersData(selectedTaxPayersData);
  //   // console.log("Seçilen Mükellefler:", selectedTaxPayersData);
  // };

  const defaultColDef = useMemo(
    () => ({
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );
  function clearLocalStorage() {
    localStorage.clear();
  }
  useEffect(() => {
    search();
  }, [pageSize, pageNumber]);
  const search = async () => {
    setLoading(true);
    if (searchForTransaction) {
      setSearchForTransaction(false);
    }
    try {
      // Taxpayer listesini al
      const taxpayer = await getTaxPayerList(pageNumber, 1000);
      setTaxpayerList(taxpayer.data.data);

      // Finansal işlemleri al
      const response = await getFinancialTransactions(
        startDate,
        endDate,
        pageSize,
        pageNumber
      );

      // taxpayerList'i bir Map'e çevir (id -> title eşleştirmesi)
      const taxpayerMap = new Map(
        taxpayer.data.data.map((item) => [item.id, item.title])
      );

      // response.data.data'ya title alanını ekle
      const enrichedData = response.data.data.map((item) => ({
        ...item,
        title: taxpayerMap.get(item.taxpayerId) || "Bilinmeyen Mükellef", // Varsayılan değer
      }));

      // Tabloya veriyi set et
      setTotalCount(response.data.count);
      setTotalPages(Math.ceil(response.data.count / pageSize) || 1);
      setRowData(enrichedData);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
      setRowData([]); // Hata durumunda boş veri
    }
    setLoading(false);
  };
  const [currentTransaction, setCurrentTransaction] = useState(null);
  useEffect(() => {
    if (searchForTransaction) {
      search();
    }
  }, [searchForTransaction]);
  const handleEditTransaction = (transactionData) => {
    setCurrentTransaction(transactionData);
    setEditModalOpen(true);
  };
  const handleDeleteTransaction = async (id) => {
    const result = await Swal.fire({
      title: "Silmek istediğinize emin misiniz?",
      text: "Bu işlemi geri alamazsınız!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Vazgeç",
    });

    if (result.isConfirmed) {
      try {
        await deleteForFinancialTransaction(id)
          .then(() => {
            search();
            Swal.fire({
              text: "Mükellef fişi silindi.",
              icon: "success",
              confirmButtonText: "Tamam",
              customClass: { container: ".swal-overlay" },
            });
          })
          .catch(() => {
            Swal.fire({
              text: "Mükellef fişi silinemedi.",
              icon: "error",
              confirmButtonText: "Tamam",
              customClass: { container: ".swal-overlay" },
            });
          });
      } catch (error) {
        console.error("Transaction deletion failed:", error);
        Swal.fire({
          text: "Bir hata oluştu. Lütfen tekrar deneyin.",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      }
    }
  };
  const [columnDefs, setColumnDefs] = useState(
    createColumnDefs(handleEditTransaction, handleDeleteTransaction)
  );

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        defaultExpanded: false,
        columnDefs: [{ field: "description" }],
        defaultColDef: {
          flex: 3,
          maxWidth: 300,
          resizable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);

  // gridRef tanımlayın (eğer henüz tanımlanmadıysa)
  const gridRef = useRef();
  // State'leri ekleyin
  const [visibleRowCount, setVisibleRowCount] = useState(0);
  const [generalBalance, setGeneralBalance] = useState(0);
  const [negativeTotal, setNegativeTotal] = useState(0);

  // Bakiyeleri hesaplayan fonksiyon
  const calculateBalances = (api) => {
    if (api) {
      // Görünen satır sayısını al
      const visibleNodes = [];
      api.forEachNodeAfterFilter((node) => visibleNodes.push(node));
      setVisibleRowCount(visibleNodes.length);

      // Bakiyeleri hesapla
      let generalBalanceSum = 0;
      let negativeTotalSum = 0;

      visibleNodes.forEach((node) => {
        const data = node.data;
        if (data) {
          // Borcu alacaktan fazla olanlar (Genel Bakiye)
          if (data.accrual > data.collection) {
            generalBalanceSum += data.accrual - data.collection;
          }

          // Alacağı borçtan fazla olanlar (- Toplam)
          if (data.collection > data.accrual) {
            negativeTotalSum += data.collection - data.accrual;
          }
        }
      });

      setGeneralBalance(generalBalanceSum);
      setNegativeTotal(negativeTotalSum);
    }
  };

  // Filtreleme değiştiğinde çağrılacak fonksiyon
  const onFilterChanged = (params) => {
    calculateBalances(params.api);
  };

  // İlk veri yüklendiğinde
  const onFirstDataRendered = (params) => {
    calculateBalances(params.api);
  };

  // useEffect ekleyelim: rowData değiştiğinde hesaplayalım
  useEffect(() => {
    if (gridApi) {
      calculateBalances(gridApi);
    }
  }, [rowData, gridApi]);

  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api); // gridApi'yi burada ayarlayın
      setRowData(rowData); // mevcut satır verilerini ayarlayın
      // gridApi hazır olduğunda da hesaplama yap
      setTimeout(() => {
        calculateBalances(params.api);
      }, 100);
    },
    [rowData]
  );

  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid item md={12} sx={{ display: "flex", flexDirection: "column" }}>
          <Grid
            className="grid-area"
            sx={{
              mb: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Başlangıç Tarihi"
                    value={moment(startDate)}
                    onChange={(newValue) => {
                      setStartDate(newValue.format("YYYY-MM-DD"));
                    }}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 160 }}
                  />

                  <DatePicker
                    label="Bitiş Tarihi"
                    value={moment(endDate)}
                    onChange={(newValue) => {
                      setEndDate(newValue.format("YYYY-MM-DD"));
                    }}
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 160 }}
                  />
                </LocalizationProvider>

                <Button
                  sx={{
                    textTransform: "none",
                    alignItems: "center",
                    gap: 1,
                    marginLeft: "1vw",

                    backgroundColor: "#00cfe8",
                    "&:hover": {
                      backgroundColor: darken(0.1, "#00cfe8"),
                      borderColor: "#d9534f",
                    },
                  }}
                  variant="contained"
                  type="submit"
                  onClick={() => search()}
                >
                  <SearchIcon color="white" />
                  Ara
                </Button>
              </Box>

              <Button
                variant="contained"
                sx={{ backgroundColor: "green" }}
                size="small"
                startIcon={<AddIcon />}
                onClick={() => {
                  setModalOpenForTransaciton(true);
                }}
              >
                Ekle
              </Button>
            </Box>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "70vh",
              maxHeight: "70vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              onFilterChanged={onFilterChanged}
              rowSelection="multiple"
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              context={{ openModal }}
              copyHeadersToClipboard={false}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              suppressRowDeselection={true}
              enableRangeSelection={true}
              rowMultiSelectWithClick={true}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "space-between",
                display: rowData?.length === 0 ? "none" : "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  borderTop: "1px solid #e0e0e0",
                  p: "5px 0px 10px 0px",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: 2,
                  backgroundColor: "#f9f9f9",
                  borderRadius: "0 0 8px 8px",
                }}
              >
                {/* Üst kısım - İstatistikler */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  {/* Görünen kayıt bilgisi */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      p: "7px 5px 2px 10px",
                      backgroundColor: "white",
                      minWidth: 150,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      Görünen Kayıt
                    </Typography>
                    <Typography variant="h6" fontWeight="bold">
                      {visibleRowCount}
                    </Typography>
                  </Box>

                  {/* Genel Bakiye */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      p: "7px 5px 2px 10px",
                      backgroundColor: "white",
                      minWidth: 150,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      Genel Bakiye
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color={generalBalance > 0 ? "error.main" : "text.primary"}
                    >
                      {generalBalance.toFixed(2)} ₺
                    </Typography>
                  </Box>

                  {/* Toplam */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      p: "7px 5px 2px 10px",
                      backgroundColor: "white",
                      minWidth: 150,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      - Toplam
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color={
                        negativeTotal > 0 ? "success.main" : "text.primary"
                      }
                    >
                      {negativeTotal.toFixed(2)} ₺
                    </Typography>
                  </Box>
                </Box>

                {/* Alt kısım - Pagination */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 3,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    p: 1.5,
                    backgroundColor: "white",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        minWidth: 60,
                        textAlign: "center",
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        px: 2,
                        py: 0.5,
                      }}
                    >
                      Toplam Kayıt: {totalCount}
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      Sayfa Boyutu:
                    </Typography>
                    <Select
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setPageNumber(1);
                      }}
                      size="small"
                      sx={{ width: 80 }}
                    >
                      {[250, 500, 1000, 2500].map((size) => (
                        <MenuItem key={size} value={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={pageNumber === 1}
                      onClick={() => setPageNumber(pageNumber - 1)}
                      startIcon={<NavigateBeforeIcon />}
                    >
                      Önceki
                    </Button>

                    <Typography
                      variant="body1"
                      sx={{
                        minWidth: 60,
                        textAlign: "center",
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        px: 2,
                        py: 0.5,
                      }}
                    >
                      {pageNumber} / {totalPages}
                    </Typography>

                    <Button
                      variant="outlined"
                      size="small"
                      disabled={pageNumber === totalPages}
                      onClick={() => setPageNumber(pageNumber + 1)}
                      endIcon={<NavigateNextIcon />}
                    >
                      Sonraki
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
            {modalOpenForTransaciton && (
              <AddFinancialTransactionModal
                open={modalOpenForTransaciton}
                onClose={() => setModalOpenForTransaciton(false)}
                taxpayerList={taxpayerList}
                initialTaxpayerId={selectedTaxpayerId}
                setSearchForTransaction={setSearchForTransaction}
              />
            )}
            {editModalOpen && (
              <EditFinancialTransactionModal
                open={editModalOpen}
                onClose={() => setEditModalOpen(false)}
                taxpayerList={taxpayerList}
                transactionData={currentTransaction}
                setSearchForTransaction={setSearchForTransaction}
                isCustomercard={false}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default FinancialTransaction;
